import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgAddSquareFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm7 6v3H8a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3V8a1 1 0 1 0-2 0Z", fill: color }));
};
export default factorySvgIcon(SvgAddSquareFilled);
//# sourceMappingURL=SvgAddSquareFilled.js.map